// Single source of truth for store branding. Consumed by the home "Shop by
// Store" grid and by the store pill on every offer card, so a colour only
// ever has to change in one place.
export const STORE_LINKS = [
  { name: 'Flipkart', slug: 'flipkart', color: '#2874F0', sub: 'Up to 80% Off' },
  { name: 'Amazon',   slug: 'amazon',   color: '#FF9900', sub: 'Daily Deals' },
  { name: 'Myntra',   slug: 'myntra',   color: '#FF3F6C', sub: 'Up to 70% Off' },
  { name: 'Ajio',     slug: 'ajio',     color: '#2D2926', sub: 'Up to 90% Off' },
];

const DEFAULT_STORE_COLOR = '#6366f1';

const STORE_COLORS = STORE_LINKS.reduce((acc, s) => {
  acc[s.name.toLowerCase()] = s.color;
  return acc;
}, {});

// Admins can type a free-text store name, so anything unknown falls back to
// the brand indigo rather than rendering an uncoloured pill.
export function storeColor(store) {
  if (!store) return DEFAULT_STORE_COLOR;
  return STORE_COLORS[store.trim().toLowerCase()] || DEFAULT_STORE_COLOR;
}
